(() => {
  if (customElements.get('prx-coming-soon')) return;

  class ComingSoon extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-close]').addEventListener('click', () => this.dismiss(), options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dismiss();
      }, options);
      this.dialog.addEventListener('pointerdown', (event) => {
        this.pointerStartedOutside = this.isOutside(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.pointerStartedOutside && this.isOutside(event)) this.dismiss();
        this.pointerStartedOutside = false;
      }, options);
      this.dialog.addEventListener('close', () => this.unlock(), options);
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) this.open();
      }, options);
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) this.dismiss();
      }, options);
      // Shopify redirects native customer submissions to this form's anchor.
      // Focus the server-rendered signup result when returning from submission.
      this.formResult = this.querySelector('[data-form-result]');
      const returningFromSignup = location.hash === '#PrxComingSoonForm' && this.formResult;
      this.open();
      // Back/forward cache restores do not reconnect custom elements.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.open();
      }, options);
      if (returningFromSignup) {
        this.formResult.focus({ preventScroll: true });
        // Remove the consumed form anchor without changing the signup result.
        history.replaceState(history.state, '', location.pathname + location.search);
      }
    }

    isOutside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    }

    open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;

    }

    dismiss() {
      this.dialog.close();
      this.unlock();
    }

    unlock() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.locked = false;
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
    }
  }

  customElements.define('prx-coming-soon', ComingSoon);
})();
